export { default as QTab } from './QTab';
export { default as QTabItem } from './QTabItem';
